import { render } from "./SubSecondStats.vue?vue&type=template&id=47ef56ab&scoped=true"
import script from "./SubSecondStats.vue?vue&type=script&lang=js"
export * from "./SubSecondStats.vue?vue&type=script&lang=js"

import "./SubSecondStats.vue?vue&type=style&index=0&id=47ef56ab&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-47ef56ab"]])

export default __exports__